export const ENTITY = {
  USERS: "users",
  CLIENTS: "clients",
  ASSOCIATED_CLIENTS: "associated_clients",
  ARTICLES: "articles",
  STORES: "stores",
  ADDITIONAL_ITEMS: "additional_items",
  CONTAINERS: "containers",
  UNITS: "units",
  SETTLEMENT_TYPES: "settlement_types",
  CLIENT_SETTLEMENT_TYPES: "client_settlement_types",
  MOVEMENTS: "movements",
  MOVEMENT_ARTICLES: "movement_articles",
  MOVEMENT_ADDITIONAL_ITEMS: "movement_additional_items",
  MOVEMENT_TYPES: "movement_types",
  LOCATIONS: "locations",
  SUBLOCATIONS: "sublocations",
  ARTICLE_LOCATIONS: "article_locations",
  LIQUIDATIONS: "liquidations",
  LIQUIDATION_BATCHES: "liquidation_batches",
  CASCADE_STARTS: "cascade_starts",
  INVENTORY_ADJUSTMENT: "inventory_adjustments",
  GROUPS: "groups",
  MOVEMENT_BATCHES: "movement_batches",
  INCOME_ENTRIES: "income_entries",
};

export const ENTITY_NAMES: Record<string, string> = {
  USERS: "usuarios",
  CLIENTS: "clientes",
  ASSOCIATED_CLIENTS: "clientes asociados",
  ARTICLES: "artículos",
  STORES: "almacenes",
  ADDITIONAL_ITEMS: "ítems adicionales",
  CONTAINERS: "contenedores",
  UNITS: "unidades",
  SETTLEMENT_TYPES: "tipos de liquidacion",
  CLIENT_SETTLEMENT_TYPES: "tipos de liquidacion de cliente",
  MOVEMENTS: "movimientos",
  MOVEMENT_ARTICLES: "artículos de movimientos",
  MOVEMENT_ADDITIONAL_ITEMS: "ítems adicionales de movimientos",
  MOVEMENT_TYPES: "tipos de movimiento",
  LOCATIONS: "ubicaciones",
  ARTICLE_LOCATIONS: "ubicaciones de artículos",
  LIQUIDATIONS: "liquidaciones",
  LIQUIDATION_BATCHES: "lotes de liquidaciones",
  CASCADE_STARTS: "tipos de cascada",
  INVENTORY_ADJUSTMENT: "ajuste de inventario",
  INCOME_ENTRIES: "preingresos",
};
